export const globalParameters = ($http: HttpApi) => ({
  create: (params: HttpParams['body'] = {}) => $http.$post('/builder/global_parameters', { body: params }),
  delete: (id: string) => $http.$delete(`/builder/global_parameters/${id}`),
  list: () => $http.$get('/builder/global_parameters'),
  update: (id: string, params: HttpParams['body'] = {}) => $http.$patch(`/builder/global_parameters/${id}`, { body: params }),
});
